export const getLevelIndex = (level, levelConfig = []) => {
  const levelFindIndex = levelConfig.findIndex(singleLevel => (
    singleLevel.id === level
  ));
  return levelFindIndex >= 0 ? levelFindIndex : 0;
};
